import { render, staticRenderFns } from "./mainJiebanContract.vue?vue&type=template&id=8608b44a&scoped=true&"
import script from "./mainJiebanContract.vue?vue&type=script&lang=js&"
export * from "./mainJiebanContract.vue?vue&type=script&lang=js&"
import style0 from "./mainJiebanContract.vue?vue&type=style&index=0&id=8608b44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8608b44a",
  null
  
)

export default component.exports